/* eslint-disable */
import { css } from '@emotion/react';
import useTheme from '../../hooks/useTheme';
export default () => {
  const { breakpoints, colors, screenSizes, borderRadius, fluidTypeScale } =
    useTheme();
  return {
    cards: css`
      ${breakpoints.l} {
        :nth-of-type(2) {
          margin-top: 3.5rem;
        }
      }
    `,

    card: css`
      grid-auto-rows: 8.3rem;
    `,

    waysContainer: css`
      border: 1px solid ${colors.lightGrey};
      border-radius: 8px;

      @media screen and (min-width: ${screenSizes.xl}) {
        width: 320px;
      }
    `,

    header: css`
      text-transform: uppercase;
      font-size: ${fluidTypeScale.font12_12};
      color: ${colors.red};
      cursor: pointer;
      letter-spacing: 0.12em;

      ${breakpoints.l} {
        font-size: ${fluidTypeScale.font12_12};
        text-align: left;
        margin-bottom: 10px;
        font-weight: 700;
      }
    `,

    description: isExpanded => css`
      font-size: ${fluidTypeScale.font18_20};
      color: ${colors.navy};
      cursor: pointer;
      ${isExpanded === true &&
      css`
        height: auto;
      `}

      ${breakpoints.l} {
        font-size: ${fluidTypeScale.font18_20};
        font-weight: 400;
        line-height: 28px;
        text-align: left;
      }
    `,
    infoSection: css`
      ${breakpoints.l} {
        min-width: 15.625rem;
      }
    `,

    learnMore: css`
      font-size: ${fluidTypeScale.font15_15} !important;
      display: flex;
      align-items: center;
      padding: 0.5rem 0px 0.5rem 0px;
      letter-spacing: 0.12em;
      line-height: 1rem;
      text-align: left;
      color: ${colors.navy};
      text-transform: uppercase;
      font-weight: 700 !important;
      ${breakpoints.l} {
        border-top: 2px solid #eceef3;
        margin-top: 1.563rem;
        display: flex;
      }
    `,
    link: css`
      color: ${colors.navy};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.navy};
        cursor: pointer;
      }
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        color: ${colors.black};
        border-bottom: 2px solid ${colors.border_black};
        outline: none;
        p img {
          filter: grayscale(100%);
        }
      }
    `,
    learnmoreArrow: css`
      margin-left: auto;
      &:focus {
        filter: grayscale(1);
      }
    `,
    imgSection: ({ desktop, mobile }, indexVal) => css`
      width: 100%;
      height: 195px;
      border-radius: 8px 8px 0px 0px;
      background: url(${mobile.src}) 0 0 no-repeat;
      background-size: cover;
      cursor: pointer;
      position: relative;
      &:focus-visible {
        outline: none;
        .youtube{
          border: 2px solid  ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }
      margin-left: 1px !important;

      ${breakpoints.l} {
        background: url(${desktop.src}) 0 0 no-repeat;
        background-size: cover;
      }

      .youtube {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        &:hover {
          filter: brightness(77%);
        }
      }
    `,
    cardalign: isExpanded => css`
      background-color: ${colors.white};
      padding: 32px 24px 8px 24px;
      ${isExpanded === true &&
      css`
        height: auto;
      `}
    `,
    quickLinkContainer: css`
      display: inline-flex;
      height: 100%;
      background-color: ${colors.white};
      padding-top: 5px;
    `,
    showMore: css`
      color: ${colors.next_grey};
      cursor: pointer;
      font-weight: 700;
      text-decoration: none;
      display: inline-block;
      &:hover {
        text-decoration: underline;
      }
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        outline: none;
        color: ${colors.border_black};
        border-bottom: 2px solid ${colors.border_black};
        
        span img {
         filter: grayscale(1) brightness(0) invert(0);
        }
      }

      ${breakpoints.l} {
        &:hover {
          text-decoration: underline;
        }
      }
    `,
    expandArrow: css`
      display: inline-block;
      margin-left: 3px;
      vertical-align: middle;
    `,
  };
};
